import { Product } from 'shared/Nps/store/product/types';
import { REVIEW_STORE_ID } from 'shared/Nps/store/review/constants';


export const getProductIndex =
(products: (null| { [key: string]: Product }) = {}, productId: string) => {
  const productData = Object.keys(products);
  return productData?.findIndex(id => (id?.toString() === productId));
};

const SHADE = 'shade';
export const isShade = (type: string) => (
  type &&
  (type.toLowerCase() === SHADE)
);

export const isMobileDevice = () => {
  const isServer = __SERVER__;
  if (!isServer && window && window.navigator) {
    return /Mobi/i.test(window.navigator.userAgent);
  }
  return false;
};

export const getStoreId = () => {
  const isMobile = isMobileDevice();
  return isMobile ? REVIEW_STORE_ID.MOBILE : REVIEW_STORE_ID.DESKTOP;
};
